import { useModalConfirmationContext } from 'src/app/shared/components/payments';
import type { PaymentType } from 'src/app/shared/utils/payments';
import { paymentMethod as getPaymentMethod } from 'src/app/shared/utils/payments';

import { usePromoteFormData } from '../../../formContext/formData';
import { usePromoteFormState } from '../../../formContext/formState';
import { useTracking } from '../useTracking';

export function useConfirmPaymentMethodOverwrite(): (paymentType: PaymentType) => Promise<boolean> {
	const {
		user: { savedPaymentMethods, hasSubscription },
	} = usePromoteFormData();

	const [
		{
			paymentMethodSaveOptions: { shouldSavePaymentMethod },
		},
	] = usePromoteFormState();

	const { trackSavedPaymentAuthModalShown } = useTracking();
	const [, { displayModal }] = useModalConfirmationContext();

	return async function confirmPaymentMethodOverwrite(paymentType: PaymentType): Promise<boolean> {
		const currentPaymentTypeGateway = getPaymentMethod(paymentType).gateway;
		// OverwritePaymentMethodConfirmationModal modal is not supported for paypal because of overlay issues
		if (!shouldSavePaymentMethod || !hasSubscription || paymentType === 'paypal') return true;
		const isReplacingPaymentMethodOnGateway = savedPaymentMethods.some(
			({ gateway }) => gateway === currentPaymentTypeGateway,
		);
		if (isReplacingPaymentMethodOnGateway) {
			trackSavedPaymentAuthModalShown({ paymentType });
			return displayModal({ type: 'overwritePaymentMethod' });
		}
		return true;
	};
}
